import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import { minifyHTML } from '../Conversion/Minifiers';
import RandomContent from '../Components/RandomContent';

const HtmlMinifier = () => {
  const [inputData, setInputData] = useState('');
  const [outputData, setOutputData] = useState('');
  const [isError, setIsError] = useState(false);
  const [fontSize, setFontSize] = useState(14);
  const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
  const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });

  useEffect(() => {
    setInputData('');
    setOutputData('');
    setIsError(false);
  }, []);

  const handleConversion = () => {
    const { minified, isError } = minifyHTML(inputData);
    setOutputData(minified);
    setIsError(isError);
  };

  return (
     <><div>
            <Header />

            <RandomContent />

            <div className="blog-area pb-20">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-12 col-md-12">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="details">
                                    <h4><a href="#">Minify HTML</a></h4>
                                    <p>Optimize your HTML files with ease using Data Beautifier's Free HTML Minifier Online Tool. Our Best HTML Minifier Online Tool compresses your HTML data by removing unnecessary spaces, line breaks, and formatting, ensuring a smaller, faster, and cleaner file. Designed for simplicity, our Simple HTML Minifier Tool requires no technical expertise, making it perfect for developers and web designers alike. With the Easy HTML Minifier Tool, you can enhance your workflow in just a few clicks. Accessible anytime and completely free, Data Beautifier provides reliable results for all your HTML compression needs. Try it today!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="blog-area pb-20">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-5 col-md-5">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="thumb">
                                    <Inputs
                                        value={inputData}
                                        setValue={(val) => {
                                            setInputData(val);
                                            setIsError(false); // Reset error on change
                                        }}
                                        fontSize={fontSize}
                                        setFontSize={setFontSize}
                                        isError={isError}
                                        lineCol={inputLnCol}
                                        setLineCol={setInputLnCol}
                                        readOnly={false}
                                        idPrefix="input" />
                                </div>
                            </div>
                        </div>

                        {/* Controls */}
                        <div
                            className="w3-col m2"
                            style={{
                                flex: 2,
                                display: 'flex',
                                justifyContent: 'center', // horizontal center
                                alignItems: 'center', // vertical center
                            }}
                        >
                            <button
                                className="default-btn icon four" onClick={handleConversion}>
                                <i className="ri-exchange-line"></i>
                                Convert
                            </button>
                        </div>

                        <div className="full-col col-lg-5 col-md-5">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="1200">
                                <div className="thumb">
                                    <Output
                                        value={outputData}
                                        lineCol={outputLnCol}
                                        setLineCol={setOutputLnCol}
                                        fontSize={fontSize}
                                        setFontSize={setFontSize}
                                        idPrefix="output" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

            <Footer />
        </>
  );
};

export default HtmlMinifier;
